/**
 * Die Begruessung beim ersten Besuch.
 *
 * Zwei Knoepfe, zwei Sprachen, eine Entscheidung: „Hello" oder „Grüezi".
 * Sie setzt die Sprache und verschwindet. Beim naechsten Mal kommt sie
 * nicht wieder, denn eine Begruessung, die man jeden Tag wegklickt, ist
 * keine Begruessung mehr.
 */
import { useEffect, useState } from 'react'

import { useLang } from '../lang'

const SCHON_DA = 'bsb.greeted'

export function Welcome() {
  const { switchTo } = useLang()
  const [zeigen, setZeigen] = useState(false)

  useEffect(() => {
    try {
      if (!localStorage.getItem(SCHON_DA)) setZeigen(true)
    } catch {
      // Privater Modus: dann halt jedes Mal. Kein Beinbruch.
      setZeigen(true)
    }
  }, [])

  function waehle(lang: 'de' | 'en') {
    switchTo(lang)
    try {
      localStorage.setItem(SCHON_DA, lang)
    } catch {
      /* egal */
    }
    setZeigen(false)
  }

  if (!zeigen) return null

  return (
    <div className="welcome" role="dialog" aria-modal="true" aria-label="Sprache / language">
      <div className="welcome__box">
        <h1 className="welcome__title">
          Bullshit<br />Bingo<span className="dot">.</span>
        </h1>
        <p className="welcome__sub">
          Das Spiel gegen leere Floskeln. · The game against empty buzzwords.
        </p>
        <div className="welcome__wahl">
          <button type="button" className="welcome__btn" onClick={() => waehle('de')}>
            <span className="welcome__hi">Grüezi</span>
            <span className="welcome__lang">Deutsch</span>
          </button>
          <button type="button" className="welcome__btn" onClick={() => waehle('en')}>
            <span className="welcome__hi">Hello</span>
            <span className="welcome__lang">English</span>
          </button>
        </div>
        <p className="welcome__by">
          {'von '}
          <a href="https://cics.ch/" target="_blank" rel="noopener">CICS</a>
          {' & ZweiOnCTI'}
        </p>
      </div>
    </div>
  )
}
